import { jsx as i } from "react/jsx-runtime";
import { UnauthenticatedAccountLink as m } from "./unauthenticated.js";
import { AuthenticatedAccountLink as A } from "./authenticated.js";
const f = (c) => {
  const {
    closeMenuModal: a,
    isAuthenticated: r,
    userImage: u,
    openAuthModal: s,
    logout: l,
    hasNotifications: d,
    isActive: t,
    isScrolledHeader: o,
    language: e,
    getTranslation: n
  } = c;
  return r ? /* @__PURE__ */ i(
    A,
    {
      userImage: u,
      logout: l,
      hasNotifications: d,
      isActive: t,
      isScrolledHeader: o,
      closeMenuModal: a,
      language: e,
      getTranslation: n
    }
  ) : /* @__PURE__ */ i(
    m,
    {
      openAuthModal: s,
      isActive: t,
      isScrolledHeader: o,
      language: e,
      getTranslation: n
    }
  );
};
export {
  f as AccountLink
};
